import React from 'react'
import useDimensions from '../../../hooks/use-dimensions'
import { get } from 'lodash'
import CheckedMultiSelector from '../checked-multi-selector'
import LabeledInput from '../labeled-input'
import { TagFill } from 'react-bootstrap-icons'

const DimensionsFilter = ({
    values = [],
    onChange = () => {},
    disabled,
    showIcon,
    label = 'Wellness Dimensions'
}) => {
    const [ dimensions ] = useDimensions()
    return (
        <LabeledInput
            iconComponent={showIcon ? TagFill : null}
            label={label}
        >
            <CheckedMultiSelector
                items={dimensions}
                title={values.length ? 'Dimensions' : 'All Dimensions'}
                onChange={onChange}
                values={values}
                disabled={disabled}
                keyProp='id'
                valueProp='name'
            />
        </LabeledInput>
    )
}

export default DimensionsFilter